'use es6';

import Raven from 'raven-js';
export function reportError(message, extra) {
  Raven.captureMessage(message, {
    extra
  });
}